module.exports = __webpack_public_path__ + "static/media/fair-trade.acde5661.png";